import styled from "styled-components";
import media from "styled-media-query";
import bicGif from '../../assets/bic.gif';

export const SectionBic = styled.section`
  background-color: #FFA521;
  height: 180px;
  width: 100%;
  display: flex;
  justify-content: center;

  .container{
    border: 1px solid red;
  }

  .gif{
    height: 100%;
    width: 100%;
    max-width: 698px;
    background: url(${bicGif});
    background-size: cover;
  }

  ${media.lessThan('1024px')`
    margin-top: 9px;
  `}

  ${media.lessThan('700px')`
    height: 85%;
  `}

`